export const CURRENT_CUSTOMER='CURRENT_CUSTOMER'
